import apiClient from '../apiClient';
import { GET_DATA_TRANSFER_LOGS_BY_ID_URL } from '../apiUrl';

const getDataTransferLogsByIdApi = Id => {
  return apiClient.get(GET_DATA_TRANSFER_LOGS_BY_ID_URL(Id));
};

export default getDataTransferLogsByIdApi;
